import { z } from "zod";

const openHoursEntry = z.object({
  enabled: z.boolean(),
  open: z.string(),
  close: z.string(),
});

const blackoutEntry = z.object({
  id: z.string(),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  allDay: z.boolean(),
  startTime: z.string().optional(),
  endTime: z.string().optional(),
  reason: z.string().optional(),
});

export const BranchScheduleSchema = z.object({
  openHours: z.record(z.string(), openHoursEntry),
  onlineOrdersEnabled: z.boolean(),
  pickupEnabled: z.boolean(),
  deliveryEnabled: z.boolean(),
  autoAccept: z.boolean(),
  slotMode: z.enum(["slots", "asap"]),
  capacityPerSlot: z.number().int().min(0).nullable(),
  cutoffMinutes: z.number().int().min(0).nullable(),
  prepBufferMinutes: z.number().int().min(0).nullable(),
  slotDurationMinutes: z.number().int().min(5).optional(),
  slotRanges: z
    .array(z.object({ start: z.string(), end: z.string() }))
    .optional(),
  blackouts: z.array(blackoutEntry),
});

export type BranchScheduleFormValues = z.infer<typeof BranchScheduleSchema>;

export type BranchScheduleSubmitPayload = {
  openHoursJson: Record<string, { open: string; close: string } | null>;
  onlineOrdersEnabled: boolean;
  pickupEnabled: boolean;
  deliveryEnabled: boolean;
  autoAccept: boolean;
  capacityPerSlot: number | null;
  cutoffMinutes: number | null;
  prepBufferMinutes: number | null;
  slotConfigJson: {
    slotDurationMinutes?: number;
    slots?: Array<{ start: string; end: string }>;
  } | null;
  blackoutDatesJson: Array<{
    id?: string;
    date: string;
    allDay?: boolean;
    startTime?: string | null;
    endTime?: string | null;
    reason?: string | null;
  }> | null;
};
